var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashWrench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,0h18.19v3.1l-1.01-.1c-.83,0-1.61.2-2.29.54-.45-.36-.74-.92-.74-1.54H4.04c0,1.11-.9,2-2.02,2v4c1.12,0,2.02.9,2.02,2h7.11l-.04.5v1.5H0V0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 9.09,
    cy: 6,
    rx: 3.03,
    ry: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.89,12.44l-3.56-3.53c.36-.89.16-1.94-.59-2.67-.78-.78-1.95-.94-2.9-.51l1.68,1.67-1.17,1.17-1.73-1.67c-.47.94-.25,2.09.51,2.88.75.74,1.8.93,2.71.58l3.56,3.52c.16.16.39.16.55,0l.9-.88c.19-.15.19-.43.03-.55Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashWrench);
export default __webpack_public_path__ + "static/media/cash-wrench.43f6e1411a42bc8c713b74f356924b8f.svg";
export { ForwardRef as ReactComponent };